import apiService from "./api";

export const login = (username: string, password: string) => {
  return apiService("/core/login/", "POST", { username, password }, false);
};

export const register = (formData: Record<string, any>) => {
  return apiService("/core/register/", "POST", formData, false);
};

export const verifyEmail = (uidb64: string, token: string) => {
  return apiService("/core/emailVerify/", "POST", { uidb64, token }, false);
};

export const refreshToken = (refresh: string) => {
  return apiService("/core/token/refresh/", "POST", { refresh }, false);
};

export const requestPasswordReset = (username: string) => {
  return apiService("/core/forgotPassword/", "POST", { username }, false);
};

export const resetPassword = (id: string, token: string, password: string) => {
  return apiService(
    "/core/resetPassword/",
    "POST",
    { uidb64: id, token, new_password: password },
    false
  );
};
